import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";  

export const ShipmentStuffingAPI = createApi({
  reducerPath: "ShipmentStuffingAPI",
  baseQuery,   
  prepareHeaders: (headers) => {
    const token = localStorage.getItem("userToken");
    if (token) headers.set("Authorization", `Bearer ${token}`);
    headers.set("X-Request-Id", crypto.randomUUID());
    return headers;
  },
  tagTypes: ["Exporter", "Ports", "Country", "CFS","ShipmentStuffing"],
  endpoints: (builder) => ({
    
    updateShipmentStuffing: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/export/shipment/stuffing/${id}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: {stuffing:data}, 
      }),
      invalidatesTags: ["ShipmentStuffing"],
    }),

    getShipmentStuffingById: builder.query({
      query: ({id}) => `export/shipment/stuffing/${id}`,
      transformResponse: (response) => response?.data?.[0]?? [],
      providesTags: ["ShipmentStuffing"],
    }),

  }),
});

export const {
  useUpdateShipmentStuffingMutation,
  useLazyGetShipmentStuffingByIdQuery,
} = ShipmentStuffingAPI;

